






































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Measurement} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";
import bus from "@/main";

@Component({
    components: {}
})
export default class MeasurementListRowValueView extends BaseComponent {

    // Bindings to parent
    @Prop() item!: Measurement;
    @Prop({default: false}) isEditable!: boolean;

    // Bindings to view
    public isReady = false;
    public startValue = -1;
    public value = -1;
    public color: 'green' | 'orange' | 'red' = 'green';
    public isInEditMode = false;
    public hasOverrideValue = false;

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.hasOverrideValue = (this.item.value_override ?? -1) > 0 && this.item.value_override != this.item.value;
        this.startValue = this.item.value_override ?? this.item.value ?? -1;
        this.value = this.startValue;
        this.updateColor();
        this.isReady = true;
    }

    @Watch('value')
    private updateColor() {
        if (this.value > 16) {
            this.color = 'red';
        } else if (this.value > 8) {
            this.color = 'orange';
        } else {
            this.color = 'green';
        }
    }

    public toggleIsInEditMode() {
        this.isInEditMode = !this.isInEditMode;
        if (!this.isInEditMode) { // Save!
            this.item.value_override = this.value;
            Api.measurements().patchById(this.item.id!)
                .save(this.item, () => {
                    bus.$emit('measurementSaved');
                });
            this.renderView();
        }
    }

}
